import React, { useState } from "react";
import { HiMenuAlt4, HiX } from "react-icons/hi";
import { Link } from "react-router-dom";

import { images } from "../constants";
import logo from "../assets/images/Logo.png";
import Menu from "./Menu";

const Navbar = () => {
  const [toggle, setToggle] = useState(false);
  const [activeLink, setActiveLink] = useState("home");

  const handleLinkClick = (link) => {
    setActiveLink(link);
  };

  const toggleMenu = () => {
    setToggle(!toggle);
  };

  return (
    <nav className="app__navbar">
      <div className="app__navbar-logo">
        <a href="/#home" className="nav-xbtext">
          <img src={logo} alt="site-logo" />
          <span>UrchDev</span>
        </a>
      </div>
      <div className="menu-links">
        <ul className="app__navbar-links">
          <li className="app__flex">
            <a
              className={`nav-text ${
                activeLink === "home" ? "active-link" : ""
              } `}
              href="/#home"
              onClick={() => handleLinkClick("home")}
            >
              <span className="p-ctext">#</span>Home
            </a>
          </li>
          <li className="app__flex">
            <a
              className={`nav-text ${
                activeLink === "projects" ? "active-link" : ""
              } `}
              onClick={() => handleLinkClick("projects")}
              href="/#projects"
            >
              <span className="p-ctext">#</span>Projects
            </a>
          </li>

          <li className="app__flex">
            <a
              className={`nav-text ${
                activeLink === "about" ? "active-link" : ""
              } `}
              href="/#about-me"
              onClick={() => handleLinkClick("about")}
            >
              <span className="p-ctext">#</span>About-me
            </a>
          </li>

          <li className="app__flex">
            <a
              className={`nav-text ${
                activeLink === "skills" ? "active-link" : ""
              } `}
              href="/#skills"
              onClick={() => handleLinkClick("skills")}
            >
              <span className="p-ctext">#</span>Skills
            </a>
          </li>

          <li className="app__flex nav-text">
            <a
              className={`nav-text ${
                activeLink === "contact" ? "active-link" : ""
              } `}
              href="/#contact"
              onClick={() => handleLinkClick("contact")}
            >
              <span className="p-ctext">#</span>Contacts
            </a>
          </li>
        </ul>
      </div>
      <div className="app__navbar-menubar">
        {toggle ? (
          <Menu
            toggleMenu={toggleMenu}
            handleLinkClick={handleLinkClick}
            activeLink={activeLink}
          />
        ) : (
          <HiMenuAlt4
            onClick={toggleMenu}
            classNameName="cursor-pointer w-[50px] h-[40px]"
          />
        )}
      </div>
    </nav>
  );
};

export default Navbar;
